// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"25ccdef8","145":"e1ee1bf0","362":"1470af66","375":"e5aa3f8d","482":"7a2ac35c","693":"2da62c7f","891":"dd1afbe8"}[chunkId] + ".chunk.js";
};